import React, { useState, useEffect } from 'react';
import { toast } from '../utils/toast';
import usersService from '../services/usersService';
import { useAuth } from '../services/AuthContext';
import './Profile.css';

const Profile = () => {
  const { user, updateUser } = useAuth();
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    display_name: '',
    full_name: '',
    inn: '',
    email: ''
  });

  useEffect(() => {
    loadProfile();
  }, []);

  const loadProfile = async () => {
    try {
      setLoading(true);
      const response = await usersService.getProfile();
      const profile = response.data;
      setFormData({
        name: profile.name || '',
        display_name: profile.display_name || '',
        full_name: profile.full_name || '',
        inn: profile.inn || '',
        email: profile.email || ''
      });
    } catch (error) {
      console.error('Error loading profile:', error);
      toast.error('Ошибка при загрузке профиля');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await usersService.updateProfile({
        name: formData.name,
        display_name: formData.display_name,
        full_name: formData.full_name,
        inn: formData.inn
      });

      // Обновляем данные пользователя в контексте
      updateUser(response.data);

      toast.success('Профиль успешно обновлен');
      setEditing(false);
    } catch (error) {
      console.error('Error updating profile:', error);
      toast.error(error.response?.data?.error || 'Ошибка при обновлении профиля');
    }
  };

  const handleCancel = () => {
    loadProfile();
    setEditing(false);
  };

  if (loading) {
    return <div className="spinner"></div>;
  }

  // Определяем отображаемое имя: display_name > name
  const displayName = formData.display_name || formData.name || user?.name || 'Пользователь';

  return (
    <div className="profile-page">
      <div className="profile-header">
        <h1>👤 Профиль пользователя</h1>
        {!editing && (
          <button onClick={() => setEditing(true)} className="btn btn-primary">
            ✏️ Редактировать
          </button>
        )}
      </div>

      <div className="profile-content">
        {editing ? (
          <form onSubmit={handleSubmit} className="profile-form">
            <div className="form-group">
              <label>Отображаемое имя *</label>
              <input
                type="text"
                value={formData.display_name}
                onChange={(e) => setFormData({ ...formData, display_name: e.target.value })}
                className="input"
                placeholder="Имя, которое будет отображаться в интерфейсе"
                required
              />
              <small>Это имя будет отображаться в интерфейсе вместо основного имени</small>
            </div>

            <div className="form-group">
              <label>Имя пользователя *</label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                className="input"
                required
              />
            </div>

            <div className="form-group">
              <label>ФИО</label>
              <input
                type="text"
                value={formData.full_name}
                onChange={(e) => setFormData({ ...formData, full_name: e.target.value })}
                className="input"
                placeholder="Полное имя (Фамилия Имя Отчество)"
              />
            </div>

            <div className="form-group">
              <label>ИНН</label>
              <input
                type="text"
                value={formData.inn}
                onChange={(e) => setFormData({ ...formData, inn: e.target.value })}
                className="input"
                placeholder="Индивидуальный номер налогоплательщика"
                maxLength="20"
              />
            </div>

            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                value={formData.email}
                className="input"
                disabled
              />
              <small>Email нельзя изменить</small>
            </div>

            <div className="form-actions">
              <button type="submit" className="btn btn-primary">
                💾 Сохранить
              </button>
              <button type="button" onClick={handleCancel} className="btn btn-secondary">
                ❌ Отмена
              </button>
            </div>
          </form>
        ) : (
          <div className="profile-info">
            <div className="info-section">
              <h2>📋 Основная информация</h2>
              <div className="info-item">
                <label>Отображаемое имя:</label>
                <p className="info-value">{displayName}</p>
              </div>
              <div className="info-item">
                <label>Имя пользователя:</label>
                <p className="info-value">{formData.name}</p>
              </div>
              <div className="info-item">
                <label>Email:</label>
                <p className="info-value">{formData.email}</p>
              </div>
            </div>

            <div className="info-section">
              <h2>🆔 Личные данные</h2>
              <div className="info-item">
                <label>ФИО:</label>
                <p className="info-value">{formData.full_name ? formData.full_name : (<span className="empty">Не указано</span>)}</p>
              </div>
              <div className="info-item">
                <label>ИНН:</label>
                <p className="info-value">{formData.inn ? formData.inn : (<span className="empty">Не указано</span>)}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Profile;
